export default __webpack_public_path__ + "siteHeading.312561dde694a5c45896d4dfd71ba446.png";